import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import {
  getCurrentUser,
  loginUser,
  logoutUser,
  changePassword,
  requireAuth,
} from "../auth/session.server";

export const login = createServerFn({ method: "POST" })
  .inputValidator(z.object({ email: z.string().email(), password: z.string().min(1) }))
  .handler(async ({ data }) => loginUser(data.email, data.password));

export const logout = createServerFn({ method: "POST" }).handler(async () => {
  await logoutUser();
  return { ok: true };
});

export const me = createServerFn({ method: "GET" }).handler(async () => {
  const user = await getCurrentUser();
  return user;
});

export const changeUserPassword = createServerFn({ method: "POST" })
  .inputValidator(
    z.object({
      currentPassword: z.string().min(1),
      newPassword: z.string().min(8),
    }),
  )
  .handler(async ({ data }) => {
    const user = await requireAuth();
    return changePassword(user.id, data.currentPassword, data.newPassword);
  });
